class Btn_Favorite {
	constructor() {
		this.selectors = {
			document: document,
			add_Favorite: '.js-add-favorite',
			removeFavorite: '.js-remove-favorite',
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

		var self = this;

		// Button adds product to Favorite List
		this.nodes.document.on('click', this.selectors.add_Favorite, (e) => {
			e.preventDefault();
			const $this = $(e.currentTarget),			
				id = $this.data('id'),
				url = $this.attr('href');				
			if ($(window).width() < 1200) {
				var favoriteIcon = $('.js-favorite-mobile');
			} else {
				var favoriteIcon = $('.js-favorite');
			}
			const favorite_icon = $('.js-favorite'),
				favorite_mobile_icon = $('.js-favorite-mobile'),
				total_count_favorite = favorite_icon.find('.js-favorite-count'),
				total_count_favorite_mobile = favorite_mobile_icon.find('.js-favorite-mobile-count'),
				imgToDrag = ( $this.data('main') == 'yes' ) ? $(document).find(".js-product-slider .slick-current img").eq(0)
				: $this.closest('.js-content').find("img:not(.brand_img, .moldova_img)").eq(0);
			$.ajax(url, {
				method: "POST",
				data: {product_id: id},
				success: function (result) {}
			});
			if ( !$this.hasClass('active-btn')) {
				e.preventDefault();
				favorite_icon.addClass('active');
				favorite_mobile_icon.addClass('active');				
				total_count_favorite.text(parseInt(total_count_favorite.text()) + 1);
				total_count_favorite_mobile.text(parseInt(total_count_favorite_mobile.text()) + 1);				
				$this.addClass('active-btn');
//				if (imgToDrag.length) {
//					const imgClone = imgToDrag.clone()
//						.offset({
//							top: imgToDrag.offset().top,
//							left: imgToDrag.offset().left
//						})
//						.css({
//							'opacity': '0.5',
//							'position': 'absolute',
//							'height': '150px',
//							'max-width': '150px',
//							'z-index': '100',
//							'bottom': 'unset',
//							'right': 'unset'
//						})
//						.appendTo($('body'))
//						.animate({
//							'top': favoriteIcon.offset().top + 10,
//							'left': favoriteIcon.offset().left + 10,
//							'max-width': 75,
//							'height': 75
//						}, 1000, 'easeInOutExpo');
//					imgClone.animate({
//						'width': 0,
//						'height': 0
//					});
//
//					setTimeout(function () {
//						favoriteIcon.addClass('pulse');
//					}, 1500);
//					setTimeout(function () {
//						favoriteIcon.removeClass('pulse');
//					}, 2000);
//				}
			} else {
				total_count_favorite.text(parseInt(total_count_favorite.text()) - 1);
				total_count_favorite_mobile.text(parseInt(total_count_favorite_mobile.text()) - 1);
				$this.removeClass('active-btn');
				if ($('.favorites-page').length > 0){
					$.ajax(url, {
						method: "POST",
						data: {product_id: id},
						success: function (result) {
							if (result.success) {
								$this.closest('.js-content').remove();
							}
							if (result.count == 0) {
								$('.js-clean-favorite-btn').hide();
								$('.empty_list').removeClass('d-none');
							}
						}
					});
				}
			}
		});
		this.nodes.document.on('click', this.selectors.removeFavorite, (e) => {
			e.preventDefault();
			var $this = $(e.currentTarget);
			var id = $this.data('id');
			var url = $this.attr('href');		
			var favorite_icon = $('.js-favorite');
			var favorite_mobile_icon = $('.js-favorite-mobile');
			var total_count_favorite = favorite_icon.find('.js-favorite-count');
			var total_count_favorite_mobile = favorite_mobile_icon.find('.js-favorite-mobile-count');
			$.ajax(url, {
				method: "POST",
				data: {product_id: id},
				success: function (result) {
					if (result.success) {						
						total_count_favorite.text(parseInt(total_count_favorite.text()) - 1);
						total_count_favorite_mobile.text(parseInt(total_count_favorite_mobile.text()) - 1);
						$this.closest('.js-content').remove();			

					}
					if (result.count == 0) {
						$('.js-clean-favorite-btn').hide();
						$('.empty_list').removeClass('d-none');
					}

					location.reload();
					
					let currentUrl = window.location.href; // Getting current Url
					let urlParts = currentUrl.split('/'); // Getting the second last part pf the URL
					let lastUrlPart = parseInt(urlParts[urlParts.length -2]);
					if ($('.product_card').length === 0) {
						if (lastUrlPart >= 3) {
							let newLastPart = lastUrlPart - 1; ` reduce the value by one`
							let newPaginationUrl = currentUrl.replace(`/${lastUrlPart}/`, `/${newLastPart}/`); // replace the second last part with the new value
							window.location.href = newPaginationUrl; // Update Window Location Href with new value
						};
						if (lastUrlPart === 2) {
							let noPaginationUrl = urlParts.slice(0, -2);
							let newUrl = noPaginationUrl.join('/') + '/';
							window.location.href = newUrl;
						};
					};
				}
			});
		});
	};
};
new Btn_Favorite();


